import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { useCreatePurchaseRequestMutation } from '../../../../api/endpoints/vehicleSale';
import { toastService } from '../../../../utils/toastService';

const CreatePurchaseRequestDialog = ({ visible, listing, onHide, onSuccess }) => {
    const { th, getCurrentLanguageId } = useLanguage();
    const languageId = getCurrentLanguageId();
    const [buyerMessage, setBuyerMessage] = useState('');

    const [createPurchaseRequest, { isLoading }] = useCreatePurchaseRequestMutation();

    useEffect(() => {
        if (visible) setBuyerMessage('');
    }, [visible]);

    if (!listing) return null;

    const handleSubmit = async () => {
        try {
            const res = await createPurchaseRequest({
                listingId: listing.listingId,
                buyerMessage: buyerMessage?.trim() || null,
                languageId
            }).unwrap();

            if (res?.isSuccess || res?.isSuccessful) {
                toastService.success(res.message || th('vehiclesForSale.toast.requestCreated'));
                onSuccess?.();
                onHide();
            }
        } catch (err) {
            void err;
        }
    };

    const footer = (
        <div className="flex justify-content-end gap-2">
            <Button
                label={th('vehiclesForSale.buttons.cancel')}
                icon="pi pi-times"
                className="p-button-outlined"
                onClick={onHide}
                disabled={isLoading}
            />
            <Button
                label={th('vehiclesForSale.buttons.submit')}
                icon="pi pi-check"
                onClick={handleSubmit}
                loading={isLoading}
            />
        </div>
    );

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header={th('vehiclesForSale.dialog.createPurchaseRequestTitle')}
            style={{ width: '480px' }}
            modal
            footer={footer}
            closable={!isLoading}
        >
            <div className="field mb-3">
                <div className="text-sm mb-2 font-medium">{listing.chassisNo}</div>
                <div className="text-sm text-600">
                    {listing.brand} · {listing.model}
                </div>
                <div className="text-sm text-600">
                    {listing.sellerBranchName}
                </div>
            </div>

            <div className="field">
                <label className="block mb-2 text-sm">
                    {th('vehiclesForSale.labels.buyerMessage')}
                </label>
                <InputTextarea
                    value={buyerMessage}
                    onChange={(e) => setBuyerMessage(e.target.value)}
                    rows={4}
                    className="w-full"
                    placeholder={th('vehiclesForSale.placeholders.buyerMessage')}
                    maxLength={500}
                />
            </div>
        </Dialog>
    );
};

export default CreatePurchaseRequestDialog;
